import { TranslationKeys } from 'types/TranslationKeys'

export interface DepartmentCardProps {
  title: string
  description: string
  url: string
  image: string
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useDepartmentCard = (props: DepartmentCardProps) => {
  return {
    ...props,
  }
}
